import React from "react";
import ReactDOM from "react-dom";
import {BrowserRouter, Route, Switch} from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.css';
import 'paper-kit-2/assets/sass/paper-kit.scss';

import Home from "views/Home.js";
import Maintenance from "views/Maintenance.js";

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route exact path="/maintenance" component={Maintenance} />
      <Route path="/" component={Home} />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
